export const boardImportExportTour = {
  key: "boardImportExport",
  version: 1,
  getSteps: (t) => [
    {
      target: '[data-tour="board-importexport-type"]',
      content: t("Tour_BoardImportExport_Type"),
      placement: "top",
      disableBeacon: true,
    },
    {
      target: '[data-tour="board-importexport-format"]',
      content: t("Tour_BoardImportExport_Format"),
      placement: "bottom",
    },
    {
      target: '[data-tour="board-importexport-mapping"]',
      content: t("Tour_BoardImportExport_Mapping"),
      placement: "right",
    },
    {
      target: '[data-tour="board-importexport-confirm"]',
      content: t("Tour_BoardImportExport_Confirm"),
      placement: "bottom",
    },
  ],
};
